import { render, staticRenderFns } from "./AssignMenu.vue?vue&type=template&id=43b8bf4d&"
import script from "./AssignMenu.vue?vue&type=script&lang=js&"
export * from "./AssignMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports